import { HOME_ROUTE } from "@/utils/const";
import { getCookie } from "@/utils/cookies";
import { Navigate, Outlet } from "react-router-dom";

const AuthRoute = () => {
  const isAuth = getCookie("isAuth") === "true";

  if (isAuth) {
    return <Navigate to={HOME_ROUTE} replace />;
  }

  return <Outlet />;
};

export default AuthRoute;
